import { Injectable } from '@angular/core';
import { HttpService } from '@lb/api/shared/http-service.class';
import { MyLBApiConfiguration } from '../mylb-api.configuration';
import { Observable } from 'rxjs';
import { IEnrollmentTagType, IUserTagType } from '../interfaces';

@Injectable({
	providedIn: 'root'
})
export class SettingsService extends HttpService {
	constructor(config: MyLBApiConfiguration) {
		super(config, 'settings');
	}

	getEnrollmentTagTypes(): Observable<IEnrollmentTagType[]> {
		return this.get<IEnrollmentTagType[]>(`${this.serviceUrl}/enrollment-tag-types`);
	}

	getUserTagTypes(): Observable<IUserTagType[]> {
		return this.get<IUserTagType[]>(`${this.serviceUrl}/user-tag-types`);
	}

	// EnrollmentTagType CRUD
	createEnrollmentTagType(tagType: Pick<IEnrollmentTagType, 'tagTypeName' | 'color'>): Observable<number> {
		return this.post<number>(`${this.serviceUrl}/enrollment-tag-types`, tagType);
	}

	updateEnrollmentTagType(id: number, tagType: Pick<IEnrollmentTagType, 'tagTypeName' | 'color'>): Observable<number> {
		return this.put<number>(`${this.serviceUrl}/enrollment-tag-types/${id}`, tagType);
	}

	deleteEnrollmentTagType(id: number): Observable<number> {
		return this.delete<number>(`${this.serviceUrl}/enrollment-tag-types/${id}`);
	}

	// UserTagType CRUD
	createUserTagType(tagType: Pick<IUserTagType, 'tagTypeName' | 'tagUserType' | 'color' | 'isAdminOnly'>): Observable<number> {
		return this.post<number>(`${this.serviceUrl}/user-tag-types`, tagType);
	}

	updateUserTagType(id: number, tagType: Pick<IUserTagType, 'tagTypeName' | 'tagUserType' | 'color' | 'isAdminOnly'>): Observable<number> {
		return this.put<number>(`${this.serviceUrl}/user-tag-types/${id}`, tagType);
	}

	deleteUserTagType(id: number): Observable<number> {
		return this.delete<number>(`${this.serviceUrl}/user-tag-types/${id}`);
	}
}
